<template>
  <router-view />
</template>

<script>
export default {
  name: 'Background'
}
</script>

<style scoped>

</style>
